var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "wow-image-upload" }, [
    _vm.value !== ""
      ? _c(
          "button",
          {
            ref: "remove",
            staticClass: "wow-image-upload__close-btn",
            attrs: { type: "button" },
            on: { click: _vm.onRemoveFile },
          },
          [_c("i", { staticClass: "mdi mdi-close" })]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.value !== ""
      ? _c("div", {
          staticClass: "wow-image-upload__preview",
          style: "background-image:url('" + _vm.value + "')",
          on: { click: _vm.onSelectFile },
        })
      : _vm._e(),
    _vm._v(" "),
    _c("input", {
      ref: "input",
      staticClass: "uk-hidden",
      attrs: { type: "file" },
      on: { change: _vm.onChange },
    }),
    _vm._v(" "),
    _vm.value === ""
      ? _c(
          "button",
          {
            staticClass: "uk-button uk-button-primary wow-payin__import_image",
            attrs: { tabindex: "-1" },
            on: { click: _vm.onSelectFile },
          },
          [
            _c("i", { staticClass: "fa fa-plus" }),
            _vm._v(" "),
            _vm._m(0),
            _vm._v(" "),
            _vm._m(1),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("เลือกรูป "),
      _c("br", { staticClass: "uk-hidden@s" }),
      _vm._v("ชำระมัดจำ"),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "uk-text-small" }, [
      _vm._v("JPEG, JPG, PNG"),
      _c("br"),
      _vm._v("ขนาดไม่เกิน 1 mb"),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }